// extracted by css-extract-rspack-plugin
var _1 = "inner-box-yyuXOf";
var _2 = "inner-box-yyuXOf";
var _3 = "more-less-button-xDMLv1";
var _4 = "more-less-button-wrapper-CtSWmF";
var _5 = "more-less-button-xDMLv1";
var _6 = "more-less-button-wrapper-CtSWmF";
var _7 = "outer-box-cqSnw7";
var _8 = "outer-box-less-tS9z0s";
var _9 = "outer-box-cqSnw7";
var _a = "outer-box-less-tS9z0s";
export { _1 as "inner-box", _2 as "innerBox", _3 as "more-less-button", _4 as "more-less-button-wrapper", _5 as "moreLessButton", _6 as "moreLessButtonWrapper", _7 as "outer-box", _8 as "outer-box-less", _9 as "outerBox", _a as "outerBoxLess" }
